(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return sectionInstagram$1; })];
        const componentsObj = hydrateComponents(components);
        await componentsObj.hydrate?.();
      })();
    });

    const {
      intersection
    } = window.PoleneLibs.Observer;
    const {
      getElementsByRef,
      ref
    } = window.PoleneLibs.Refs;
    const classes = {
      loaded: 'is-loaded'
    };
    var sectionInstagram = () => {
      const {
        instagram
      } = getElementsByRef(['instagram']);
      if (!instagram || !(instagram instanceof HTMLElement)) return;
      const {
        image
      } = getElementsByRef(['image'], instagram);
      const images = Array.isArray(image) ? image : [image];
      const {
        fetchUrl
      } = ref.instagram.dataset;
      const init = () => {
        intersection(instagram, handleIntersection, {
          threshold: [0],
          rootMargin: `0px 0px 1000px 0px`
        });
      };
      const handleIntersection = ([entry]) => {
        if (entry.isIntersecting) {
          getInstagramData();
        }
      };
      const getInstagramData = () => {
        if (!fetchUrl) return;
        const imageData = fetch(fetchUrl).then(res => res.json()).then(({
          data
        }) => data);
        imageData.then(data => {
          images.forEach(img => {
            const idx = img?.dataset.index;
            if (!data || !idx || !data[idx]) return;
            img.src = data[idx]?.images?.standard_resolution?.url;
            img.srcset = `${data[idx]?.images?.standard_resolution?.url} 20w`;
            img.classList.add(classes.loaded);
          });
        });
      };
      init();
      return () => {};
    };

    var sectionInstagram$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionInstagram
    });

})();
